import type { ImageProps } from 'next/image';

import gridBreakpoints from 'base/configs/grid.breakpoints';
import { getImageSize } from './getImageSize';
import { getImageUrl } from './getImageUrl';

export const getImageSrcSet = (src?: ImageProps['src']): string | undefined => {
  const url = getImageUrl(src);
  const { width, height } = getImageSize(src);

  if (!url || !width || !height) {
    return undefined;
  }

  const screens = Object.values(gridBreakpoints).slice(1);
  const sets = [];

  for (const screen of screens) {
    const scale = screen / width;
    const src = new URL(url);

    src.searchParams.set('width', `${Math.round(width * scale)}`);
    src.searchParams.set('height', `${Math.round(height * scale)}`);

    sets.push(`${src} ${screen}w`);
  }

  return sets.join(', ');
};
